import { Autocomplete, Box, Chip, Popper, TextField } from "@mui/material"
import { isNil } from "lodash"
import { useState } from "react"
import Barinade from "../../core/assets/oot/boss/OoT_Barinade.png"
import Bongo from "../../core/assets/oot/boss/OoT_Bongo_Bongo.png"
import Ghoma from "../../core/assets/oot/boss/OoT_Gohma.png"
import KingDodong from "../../core/assets/oot/boss/OoT_King_Dodongo.png"
import Morpha from "../../core/assets/oot/boss/OoT_Morpha.png"
import PhantomGanon from "../../core/assets/oot/boss/OoT_Phantom_Ganon.png"
import Twinrova from "../../core/assets/oot/boss/OoT_Twinrova.png"
import Volvagia from "../../core/assets/oot/boss/OoT_Volvagia.png"
import LigthArrow from "../../core/assets/oot/classic/OoT_Light_Arrow_Icon.png"
import Time from "../../core/assets/oot/classic/OoT_Ocarina_of_Time_Icon.png"
import Triforce from "../../core/assets/oot/classic/Triforce_Artwork.png"
import Bridge from "../../core/assets/oot/classic/bridge.jpg"


export interface GoalDto {
    name: string,
    tags: Array<string>,
    img: string
}
const bossData: Array<GoalDto> = [
    { name: "Ghoma", tags: ["Spider", "Deku"], img: Ghoma },
    { name: "King Dodongo", tags: ["KD", "Goron"], img: KingDodong },
    { name: "Barinade", tags: ["Bari", "Chateau"], img: Barinade },
    { name: "Phantom Ganon", tags: ["PG", "Forest"], img: PhantomGanon },
    { name: "Volvagia", tags: ["KAK", "Cocorico"], img: Volvagia },
    { name: "Morpha", tags: ["Tentacule", "Eau"], img: Morpha },
    { name: "Bongo Bongo", tags: ["BB", "Bongo"], img: Bongo },
    { name: "Twinrova", tags: ["TR", "Sorciere"], img: Twinrova },
    { name: "Time", tags: [], img: Time },
    { name: "Evil's Bane", tags: ["evil", "la"], img: LigthArrow },
    { name: "Pah of the Hero", tags: ["evil", "la"], img: LigthArrow },
    { name: "Tower", tags: ["tower"], img: Bridge },
    { name: "Gold", tags: ["Triforce"], img: Triforce },
]


interface GoalAutocompleteProps {
    label?: string
    additionalOnChange?: (value: GoalDto | null) => void,
    selection?: GoalDto | null
}

const GoalAutocomplete = (params: GoalAutocompleteProps) => {


    let [goal, setGoal] = useState<GoalDto | null>(params.selection ?? null)

    if (!isNil(goal))
        return <Box onContextMenu={(e) => {
            e.preventDefault();
            setGoal(null);
            if (!isNil(params.additionalOnChange))
                params.additionalOnChange(null)
        }
        }
            display="flex" alignItems="center">
            <img src={goal.img} alt={goal.name} height={"40px"} width={"50px"} />
            {/* {goal.name} */}
        </Box>
    return <Autocomplete
        options={bossData}
        renderInput={(props) => <TextField
            {...props}
            label={params.label ?? "Goal"}
            sx={{ width: "75px" }}

        />}

        PopperComponent={(props) => <Popper {...props} sx={{ width: "180px!important" }} placement="bottom-start"/>}

        renderTags={(values) =>
            values.map((value) => (
                <Chip
                    label={value.name}
                    icon={<img src={value.img} alt={value.name} height={30} width={30} />}
                />
            ))
        }
        renderOption={(props, option, state) => {
            return (
                <li {...props}>
                    <img src={option.img} alt={option.name} height={30} width={30} />
                    {option.name}
                </li>
            )
        }}
        onChange={(e, v) => {
            setGoal(v);
            if (!isNil(params.additionalOnChange))
                params.additionalOnChange(v);
        }}
        value={params.selection}
        getOptionLabel={(o) => o.name}
        filterOptions={(o, v) => o.filter(x => x.name.toLowerCase().includes(v.inputValue.toLowerCase()) || x.tags.some(t => t.toLowerCase().includes(v.inputValue.toLowerCase())))}
        sx={{ maxWidth: "150px" }}
        fullWidth
        size='small'
    />
}

export default GoalAutocomplete